module.exports = __webpack_public_path__ + "img/resultado-municipal-2026-q2.eb79adea.png";